import "react-app-polyfill/stable";

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import App from "./App";

import { ThemeProvider } from "./contexts/ThemeContext";
import { ErrorBoundary } from "react-error-boundary";
import { reCaptchaSiteKey } from "./config";

const container = document.getElementById("root");
const root = createRoot(container!);

const FallbackUI = () => <div>Oops, something went wrong</div>;

root.render(
  <BrowserRouter>
    <ThemeProvider>
      {/*
       * The reCAPTCHA provider must stay mounted even when the error boundary
       * trips: react-google-recaptcha-v3's unmount cleanup nulls
       * window.___grecaptcha_cfg, which leaves Google's reCAPTCHA runtime
       * throwing on every internal timer tick until reload.
       * See specs/bugs/BUG-2026-10-30T124816-recaptcha-nc-typeerror-rum-noise.md
       */}
      <GoogleReCaptchaProvider reCaptchaKey={reCaptchaSiteKey}>
        <ErrorBoundary
          fallback={<FallbackUI />}
          onError={(error, info) => console.error(error, info)}
        >
          <App />
        </ErrorBoundary>
      </GoogleReCaptchaProvider>
    </ThemeProvider>
  </BrowserRouter>
);
